const FORM_TYPES = new Set(['form', 'data form', 'data_form'])
const FILE_TYPES = new Set([
  'data',
  'data ev',
  'data_ev',
  'data rpa',
  'data_rpa',
  'data find file',
  'data_find_file',
  'find file',
  'file',
  'select file',
])

const clone = value => JSON.parse(JSON.stringify(value))

function normalizeType(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[-]+/g, ' ')
}

export function normalizeRpaInputKind(field = {}) {
  const values = [
    field.type,
    field.activity_type,
    field.block_type,
    field.input_type,
  ].map(normalizeType).filter(Boolean)
  if (values.some(value => FORM_TYPES.has(value))) return 'form'
  if (values.some(value => FILE_TYPES.has(value))) return 'file'
  return 'value'
}

function formSectionOf(value = {}) {
  return value?.selectedMultiTableDataList?.[0]?._document_detail_sections?.[0] || null
}

export function getRpaFormInitialData(field = {}) {
  if (normalizeRpaInputKind(field) !== 'form') return null
  const initial = field.initial_form_data || {
    selectedMultiTableDataList: field.source?.selectedMultiTableDataList || field.selectedMultiTableDataList || [],
  }
  const section = formSectionOf(initial)
  if (!section || !Array.isArray(section.section_headers) || !Array.isArray(section.section_rows)) return null
  return clone(initial)
}

export function mergeRpaInputFieldsWithFlowBlocks(fields = [], flowList = []) {
  const blocksById = new Map(flowList
    .filter(block => block?.id !== undefined && block?.id !== null)
    .map(block => [String(block.id), block]))
  return fields.map(field => {
    if (normalizeRpaInputKind(field) !== 'form') return { ...field }
    const block = blocksById.get(String(field.activity_id ?? field.key))
    const selectedMultiTableDataList = block?.selectedMultiTableDataList ||
      field.source?.selectedMultiTableDataList ||
      field.selectedMultiTableDataList ||
      []
    return {
      ...field,
      initial_form_data: {
        selectedMultiTableDataList: clone(selectedMultiTableDataList),
      },
    }
  })
}

export function isRpaInputSourceCompatible(field, sourceWorkItem = {}) {
  const sourceType = sourceWorkItem.item_type
  if (!sourceType) return true
  if (['manual', 'manual_check'].includes(sourceType)) return true

  const inputKind = normalizeRpaInputKind(field)
  if (inputKind === 'form') return sourceType === 'form_input'
  if (inputKind === 'file') return sourceType === 'file_input'
  return false
}

export function buildRpaFormInputMappingRow(field = {}, sourceWorkItem = {}) {
  if (normalizeRpaInputKind(field) !== 'form' || !isRpaInputSourceCompatible(field, sourceWorkItem)) {
    throw new Error('RPA 입력 유형과 선행 할일 유형이 일치하지 않습니다.')
  }

  const sourceWorkItemId = sourceWorkItem.id || sourceWorkItem.work_item_id
  if (!sourceWorkItemId) {
    throw new Error('매핑할 선행 할일을 찾을 수 없습니다.')
  }

  return {
    source_work_item_id: sourceWorkItemId,
    source_item_client_key: sourceWorkItem.client_key || sourceWorkItem.key || '',
    source_work_item_name: sourceWorkItem.name || '',
    source_work_item_type: sourceWorkItem.item_type || '',
    input_type: 'form',
    activity_id: field.activity_id ?? field.key,
    rpa_block_id: field.block_id ?? field.activity_id ?? field.key,
    rpa_play_type: field.rpa_play_type,
  }
}
